import { capitaliseFirst } from '../../../../utils/stringUtils';
import { ValidationType } from '../../../../react-app-env';
import { validateEmailAddress } from '../../../../utils/validators';

export interface OrganisationUser {
  first_name: string;
  last_name: string;
  email: string;
  active: boolean;
}
export interface Organisation {
  id: string;
  name: string;
}

export interface ValidationErrors {
  first_name: ValidationType;
  last_name: ValidationType;
  email: ValidationType;
  email_invalid: ValidationType;
}

export const validationErrors: ValidationErrors = {
  first_name: 'Please provide a first name',
  last_name: 'Please provide a last name',
  email: 'Please provide an email address',
  email_invalid: 'Please provide a valid email address',
};

export interface Validation {
  first_name: (value: string) => ValidationType;
  last_name: (value: string) => ValidationType;
  email: (value: string) => ValidationType;
}

export const validation: Validation = {
  first_name: (value) => (!value ? validationErrors.first_name : false),
  last_name: (value) => (!value ? validationErrors.last_name : false),
  email: (value) => {
    if (!value) return validationErrors.email;
    if (!validateEmailAddress(value)) return validationErrors.email_invalid;
    return false;
  },
};

export enum OrganisationUserReducerAction {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  ACTIVE,
  INIT,
}

export const organisationUserReducer = (state: OrganisationUser, action: { type: OrganisationUserReducerAction; value: any }): OrganisationUser => {
  switch (action.type) {
    case OrganisationUserReducerAction.FIRST_NAME:
      return { ...state, first_name: capitaliseFirst(action.value) };
    case OrganisationUserReducerAction.LAST_NAME:
      return { ...state, last_name: capitaliseFirst(action.value) };
    case OrganisationUserReducerAction.EMAIL:
      return { ...state, email: action.value?.toLowerCase().replace(/ /g, '') };
    case OrganisationUserReducerAction.ACTIVE:
      return { ...state, active: action.value as boolean };
    case OrganisationUserReducerAction.INIT:
      const { first_name, last_name, email, active } = action.value;
      const obj = {
        first_name,
        last_name,
        email,
        active,
      };
      return { ...(obj as OrganisationUser) };
    default:
      throw new Error();
  }
};
